import React from "react";
import { Box, Typography, Button, useTheme } from "@mui/material";
import { lightTheme } from "../../styles/theme";

interface DraftNoticesToastProps {
  compact?: boolean;
  count: number;
  onViewDrafts: () => void;
}

const DraftNoticesToast: React.FC<DraftNoticesToastProps> = ({ count, onViewDrafts, compact = false }) => {
  const theme = useTheme();

  if (count === 0) return null;

  return (
    <Box
      sx={{
        mt: compact ? 1 : 2,
        p: compact ? 1 : 2,
        borderRadius: 2,
        bgcolor: theme.palette.cards?.orangeBg || lightTheme.colors.cardOrangeHover,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flex: 1 }}>
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: "50%",
            bgcolor: theme.palette.warning.main,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <Typography
            sx={{
              color: lightTheme.colors.white,
              fontSize: (theme) => theme.typography.body2.fontSize,
              fontWeight: 600,
              lineHeight: 1,
            }}
          >
            i
          </Typography>
        </Box>
        <Typography
          sx={{
            color: theme.palette.warning.main,
            fontSize: (theme) => theme.typography.body2.fontSize,
            fontWeight: 500,
          }}
        >
          You have {count} unpublished {count === 1 ? "notice" : "notices"}
        </Typography>
      </Box>
      <Button
        size="small"
        onClick={onViewDrafts}
        sx={{
          textTransform: "none",
          fontWeight: 500,
          color: theme.palette.warning.main,
          minWidth: "auto",
          px: 1.5,
          "&:hover": {
            bgcolor:
              theme.palette.cards?.orangeHover ||
              theme.palette.cards?.orangeBg ||
              lightTheme.colors.cardOrangeHover,
          },
        }}
      >
        View Drafts
      </Button>
    </Box>
  );
};

export default DraftNoticesToast;
